import * as PIXI from "pixi.js";
import Vector from "../../util/vector";

export default class Photo {
    constructor(i, resource) {
        //velocityは単位ベクトルにする
        this.resource = resource;
        this.index = i;
        this.grid = window.innerWidth <= 768 ? 3 : 10;
        this.size = this.setSize();
        this.row = 0;
        this.mass = 1;
        this.position = this.setPosition(i);
        this.velocity = this.setVelocity();
        this.acceleration = new Vector(0, 0);
        this.appearV = 0.1;
        this.g = new PIXI.Container();
        this.g.alpha = 1 - this.setInitialAlpha();

        this.init();
    }

    init() {
        this.factory();
        this.setInitialAlpha();
    }

    arrayShuffle([...array]) {
        for (let i = array.length - 1; i >= 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    }

    setInitialAlpha() {
        return this.index * 0.1;
    }

    setPosition(i) {
        //gridの数に対して左右分+2
        const grid = this.grid + 2;

        //行
        const row = Math.floor(i / grid);

        //左右にループ用に一つ余分に生成
        let x = row === 0 ? this.size.width * i : this.size.width * (i - row * grid);

        //一つ分オフセット
        x = x - this.size.width;

        const y = row * this.size.height;

        this.row = row;
        return new Vector(x, y);
    }

    setSize() {
        //サイズを分割数に合わせる
        const w = (window.innerWidth * window.devicePixelRatio) / this.grid;
        const h = w / 1.777;

        return { width: w, height: h };
    }

    setVelocity() {
        const x = this.row % 4 <= 1 ? 0.5 : -0.5;
        return new Vector(x, 0);
    }

    randLimit(min, max) {
        return Math.random() * (max - min) + min;
    }

    applyForce(force) {
        const f = force.divide(this.mass);
        this.acceleration = this.acceleration.add(f);
    }

    update(t) {
        this.velocity = this.velocity.add(this.acceleration);
        this.position = this.position.add(this.velocity);

        if (!this.appear) {
            this.g.alpha += this.appearV;
        }

        if (this.g.alpha >= 1) {
            this.appear = true;
        }

        if (this.position.x < -this.size.width) {
            this.position.x = this.size.width * this.grid;
        } else if (this.position.x > this.size.width * this.grid) {
            this.position.x = -this.size.width;
        }
    }

    remap() {
        this.size = this.setSize();
        this.position = this.setPosition(this.index);
        this.g.width = this.size.width;
        this.g.height = this.size.height;
    }

    factory() {
        const names = Object.keys(this.resource.sprite.textures);
        const s_names = this.arrayShuffle(names);
        //const s_names = names;
        const number = this.index % names.length;
        const sprite = new PIXI.Sprite.from(s_names[number]);
        this.g.addChild(sprite);
        this.g.width = this.size.width;
        this.g.height = this.size.height;
    }

    display() {
        this.g.position.x = this.position.x;
        this.g.position.y = this.position.y;
    }
}
